import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

type Props = {
  children: string
}

export const Markable = ({ children }: Props) => {
  return (
    <div className="markable-component bg-gray-50 text-sm">
      <ReactMarkdown remarkPlugins={[remarkGfm]} skipHtml={false}>
        {children}
      </ReactMarkdown>
    </div>
  )
}
